import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { Printer, X } from "lucide-react";

// A4-Etikettenbogen: QR (oeffnet die Scan-Ansicht /d/{AssetID}) + AssetID + Kontext.
export default function LabelSheet({ devices, onClose, de }) {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const print = () => {
    document.body.classList.add("print-sheet");
    const done = () => { document.body.classList.remove("print-sheet"); window.removeEventListener("afterprint", done); };
    window.addEventListener("afterprint", done);
    window.print();
    setTimeout(done, 1500);
  };
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4" onClick={onClose} data-testid="label-sheet-modal">
      <div className="bg-white text-black rounded-lg w-full max-w-3xl max-h-[85vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
        <div className="flex justify-between items-center p-4 border-b border-gray-200">
          <span className="text-sm font-semibold text-gray-700">{de ? `Etiketten drucken (${devices.length})` : `Print labels (${devices.length})`}</span>
          <div className="flex items-center gap-2">
            <button onClick={print} data-testid="label-sheet-print" className="flex items-center gap-2 bg-gray-900 text-white rounded-lg px-3 py-2 text-sm"><Printer className="w-4 h-4" /> {de ? "Drucken" : "Print"}</button>
            <button onClick={onClose} data-testid="label-sheet-close"><X className="w-5 h-5 text-gray-500" /></button>
          </div>
        </div>
        <div className="overflow-auto p-4">
          <div className="label-sheet grid grid-cols-2 sm:grid-cols-3 gap-3">
            {devices.map((d) => {
              const sub = d.device_code || d.former_code || d.scanner_serial || "";
              const ctx = d.location_name || (d.teamviewer_id ? `TV ${d.teamviewer_id}` : "");
              return (
                <div key={d.asset_tag} className="label-cell flex flex-col items-center gap-1 border border-gray-300 rounded p-3">
                  <QRCodeSVG value={`${origin}/d/${encodeURIComponent(d.asset_tag || "")}`} size={92} level="M" />
                  <div className="text-lg font-bold tracking-wide">{d.asset_tag}</div>
                  <div className="text-[11px] text-gray-700 text-center break-all">{sub}{sub && ctx ? " · " : ""}{ctx}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
